import { ExchangeProvider } from './Context';
import { ExecuteButton } from './ExecuteButton';
import { InfoCard } from './InfoCard';
import { Input } from './Input';
import { MarketPrice } from './MarketPrice';
import { Output } from './Output';
import { ExchangeRoot } from './Root';
import { SwitchButton } from './SwitchButton';
import { TextFees } from './TextFees';
import { TextOutput } from './TextOutput';
import { Redeem } from './redeem';

import { LST } from './lst';

const Exchange = () => {};

Exchange.InfoCard = InfoCard;
Exchange.Root = ExchangeRoot;
Exchange.Context = ExchangeProvider;
Exchange.Input = Input;
Exchange.Output = Output;
Exchange.TextOutput = TextOutput;
Exchange.TextFees = TextFees;
Exchange.ExecuteButton = ExecuteButton;
Exchange.MarketPrice = MarketPrice;
Exchange.SwitchButton = SwitchButton;
Exchange.LST = LST;
Exchange.Redeem = Redeem;

export default Exchange;
